export enum HealthCoachingRoutes {
  INDEX = 'healthCoachingForm',
}
